var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
import defaultTheme from "./defaultTheme";
var ifTrue = function ifTrue(val) {
  return !!val || val === 0;
};
var theme = function theme(property) {
  return function (p) {
    return p.theme && p.theme[property] || defaultTheme[property];
  };
};
export var zIndex = function zIndex(el) {
  return function (p) {
    return p.theme.zIndex.indexOf(el) + 1;
  };
};
export var em = function em(val) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  return typeof val === "number" && val !== 0 ? val / base + "em" : val;
};
export var rem = function rem(val) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  return typeof val === "number" && val !== 0 ? val / base + "rem" : val;
};

// Get value in pixels from breakpoint key (e.g. "mobileSm" or "_1200" or 1200).
export var breakpointRaw = function breakpointRaw(key) {
  return function (p) {
    var localValue = typeof key === "number" ? key : parseInt(key.slice(1), 10);
    var isLocal = !isNaN(localValue); // eslint-disable-line

    return isLocal ? localValue : theme("breakpoints")(p)[key];
  };
};
export var breakpoint = function breakpoint(key) {
  return function (p) {
    return em(breakpointRaw(key)(p));
  };
};
export var maxBreakpoint = function maxBreakpoint(key) {
  return function (p) {
    return em(breakpointRaw(key)(p) - 1);
  };
};
export var isBreakpointKey = function isBreakpointKey(key) {
  return function (p) {
    return !!breakpointRaw(key)(p);
  };
};
export var minmax = function minmax(min, max) {
  return function (p) {
    return "@media (min-width:" + breakpoint(min)(p) + ")\n      and (max-width:" + maxBreakpoint(max)(p) + ")";
  };
};
export var min = function min(key) {
  var conditions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return function (p) {
    return "@media (min-width:" + breakpoint(key)(p) + ") " + conditions;
  };
};
export var max = function max(key) {
  var conditions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return function (p) {
    return "@media (max-width:" + maxBreakpoint(key)(p) + ") " + conditions;
  };
};
export var isSpaceKey = function isSpaceKey(key) {
  return function (p) {
    var isNegative = /^-.+/.test(key);
    var absKey = isNegative ? key.slice(1) : key;
    return !!theme("space")(p)[absKey];
  };
};
export var spaceRaw = function spaceRaw(val) {
  return function (p) {
    if (typeof val === "number") return val;
    if (typeof val === "function") return val(theme("space")(p));
    if (!isSpaceKey(val)(p)) return val;
    var isNegative = /^-.+/.test(val);
    var key = isNegative ? val.slice(1) : val;
    var keyVal = theme("space")(p)[key];
    keyVal = isNegative ? keyVal * -1 : keyVal;
    return keyVal;
  };
};
export var space = function space(val) {
  return function (p) {
    if (typeof val === "number") return rem(val);
    return rem(spaceRaw(val)(p));
  };
};

// Get CSS rules or @media blocks with rules.
export var computeStyles = function computeStyles(propValue, rules) {
  return function (p) {
    var isPropBoolean = typeof rules === "string";
    var isPropValueBoolean = typeof propValue === "boolean";
    var isPropValueNumber = typeof propValue === "number";
    var isPropValueString = typeof propValue === "string";
    var isPropValueFunction = typeof propValue === "function";

    // Given: <Component prop />
    //        <Component prop={true} />
    if (isPropBoolean && isPropValueBoolean) return rules;

    // Given: <Component prop />
    //        <Component prop={true} />
    // when prop shouldn't be a boolean
    if (!isPropBoolean && isPropValueBoolean) return rules;

    // Given: <Component prop={100} />
    //        <Component prop="50%" />
    //        <Component prop="50vw" />
    //        <Component prop="50rem" />
    //        <Component prop="50px" />
    // and isPropBoolean
    if ((isPropValueNumber || isPropValueString) && isPropBoolean) return rules;

    // Given: <Component prop={100} />
    //        <Component prop={() => {}} />
    //        <Component prop="50%" />
    //        <Component prop="50vw" />
    //        <Component prop="50rem" />
    //        <Component prop="50px" />
    if (isPropValueNumber || isPropValueString || isPropValueFunction) return rules(propValue);

    // If we are here propValue must be breakpoints object
    var breakpoints = propValue;

    // Sort breakpoints by width in ascending order
    breakpoints = Object.keys(breakpoints).sort(function (a, b) {
      return breakpointRaw(a)(p) - breakpointRaw(b)(p);
    }).reduce(function (acc, key) {
      acc[key] = breakpoints[key];
      return acc;
    }, {});

    // Given:
    // <Component prop={{ tabletSm: true }} />
    // -> @media (min-width: tabletSm) { rules }
    //
    // <Component prop={{ mobileSm: true, tabletSm: false }} />
    // -> @media (min-width: mobileSm) and (max-width: tabletSm) { rules }
    //
    // <Component prop={{ mobileSm: true, tabletSm: false, laptopSm: true }} />
    // -> @media (min-width: mobileSm) and (max-width: tabletSm) { rules }
    //    @media (min-width: laptopSm) { rules }
    //
    // <Component prop={{ mobileSm: true, tabletSm: false, laptopSm: true, _1920: false }} />
    // -> @media (min-width: mobileSm) and (max-width: tabletSm) { rules }
    //    @media (min-width: laptopSm) and (max-width: _1920) { rules }
    if (isPropBoolean) {
      // Create array with pairs of breakpoints
      // so we could set "(min) and (max)" @media rules
      var _Object$keys = Object.keys(breakpoints),
        length = _Object$keys.length;
      var pairs = [];
      for (var i = 0; i < length; i += 2) {
        pairs.push([Object.keys(breakpoints)[i], Object.keys(breakpoints)[i + 1]]);
      }
      var _CSSString = pairs.reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          minKey = _ref2[0],
          maxKey = _ref2[1];
        var minWidth = "(min-width:" + breakpoint(minKey)(p) + ")";
        var maxWidth = maxKey ? "and (max-width:" + breakpoint(maxKey)(p) + ")" : "";
        return acc + " @media " + minWidth + " " + maxWidth + "{" + rules + "}";
      }, "");
      return _CSSString;
    }

    // Given <Component prop={{ mobileSm: 16, tabletSm: 32 }} />
    // -> @media (min-width: mobileSm) { rules(16) }
    //    @media (min-width: tabletSm) { rules(32) }
    //
    // Given <Component prop={{ mobileSm: "first value", _1000: "second value" }} />
    // -> @media (min-width: mobileSm) { rules("first value") }
    //    @media (min-width: _1000) { rules("second value") }
    var CSSString = Object.keys(breakpoints).reduce(function (acc, key) {
      var minWidth = breakpoint(key)(p);
      var currentVal = breakpoints[key];
      return acc + " @media (min-width:" + minWidth + "){" + rules(currentVal) + "}";
    }, "");
    return CSSString;
  };
};
export var rule = function rule(userRules, breakpoints) {
  return function (p) {
    var rules = typeof userRules === "function" ? function (val) {
      return userRules(space(val)(p), spaceRaw(val)(p), p);
    } : function (val) {
      return userRules + ": " + space(val)(p);
    };
    return computeStyles(breakpoints, rules)(p);
  };
};
export var prop = function prop(propName, userRules) {
  return function (p) {
    var breakpoints = p[propName];

    // return empty string to avoid undefined rules
    if (!ifTrue(breakpoints)) return "";
    var rules = void 0;
    if (userRules) {
      rules = typeof userRules === "function" ? function (val) {
        return userRules(space(val)(p), spaceRaw(val)(p), p);
      } : userRules;
    } else {
      rules = function rules(val) {
        return propName + ": " + space(val)(p);
      };
    }
    return computeStyles(breakpoints, rules)(p);
  };
};
export var spaceKeyProp = function spaceKeyProp(userRules) {
  return function (p) {
    var val = Object.keys(p).filter(function (key) {
      return isSpaceKey(key)(p);
    })[0];

    // return empty string to avoid undefined rules
    if (!val) return "";
    return typeof userRules === "function" ? userRules(space(val)(p), spaceRaw(val)(p), p) : userRules + ": " + space(val)(p);
  };
};
export var breakpointProp = function breakpointProp(userRules) {
  return function (p) {
    var breakpoints = Object.keys(p).filter(function (propName) {
      return isBreakpointKey(propName)(p);
    }).reduce(function (acc, propName) {
      acc[propName] = p[propName];
      return acc;
    }, {});
    return rule(userRules, breakpoints)(p);
  };
};
export var spaceProp = function spaceProp(userRules) {
  return function (p) {
    return spaceKeyProp(userRules)(p) + "; " + breakpointProp(userRules)(p);
  };
};
export var minmaxProp = function minmaxProp(userRules) {
  return function (p) {
    var minWidth = p.min ? "(min-width:" + breakpoint(p.min)(p) + ")" : "";
    var maxWidth = p.max ? "(max-width:" + breakpoint(p.max)(p) + ")" : "";
    var and = minWidth && maxWidth ? "and" : "";
    if (!p.min && !p.max) return userRules;
    return "@media " + minWidth + " " + and + " " + maxWidth + "{" + userRules + "}";
  };
};
var insetRules = function insetRules(val) {
  return function (p) {
    if (Array.isArray(val)) {
      var _val = _slicedToArray(val, 2),
        y = _val[0],
        x = _val[1];
      return "padding:" + space(y)(p) + " " + space(x)(p) + ";";
    }
    return "padding:" + space(val)(p) + ";";
  };
};
export var inset = function inset(y, x) {
  return function (p) {
    if ((typeof y === "undefined" ? "undefined" : _typeof(y)) === "object") {
      return computeStyles(y, function (val) {
        return insetRules(val)(p);
      });
    }
    var val = ifTrue(x) ? space(y)(p) + " " + space(x)(p) : space(y)(p);
    return "padding:" + val + ";";
  };
};